import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Caption01, ProductiveHeading04 } from 'components/styles';
import { useTranslate } from 'hooks/use-translation';

const Meta = styled.p`
  ${Caption01};
  margin: 0;
  display: inline;
`;
const Data = styled.p`
  ${ProductiveHeading04};
  display: inline;
  margin: 0;
`;

const DeviationInfo = ({ days, translate, isHeader }) => {
  const info =
    days <= 0
      ? translate('reports.template_insight.widget.early_by')
      : translate('reports.template_insight.widget.delay_by');

  if (Number.isNaN(days) || days == null) {
    return <Meta> {NaN} </Meta>;
  }

  const DataComponent = isHeader ? Data : Meta;

  return (
    <>
      <Meta>{info}</Meta>
      <DataComponent> {Math.abs(days)} </DataComponent>
      <Meta>{translate('days')}</Meta>
    </>
  );
};

const DayInfo = ({ days, translate, isHeader }) => {
  const info = translate('days');

  if (isHeader) {
    return (
      <>
        <Data> {Math.abs(days)} </Data>
        <Meta>{info}</Meta>
      </>
    );
  }

  return (
    <Meta>
      {Math.abs(days)} {info}
    </Meta>
  );
};

export const useWidgetTransformer = () => {
  const translate = useTranslate();

  return useMemo(
    () => ({
      plainText: (result) => result,
      toDays: (day, isHeader = true) => (
        <DayInfo days={day} translate={translate} isHeader={isHeader} />
      ),
      toPercent: (value) =>
        translate('reports.template_insight.widget.percent', { value }),
      toDeviation: (days, isHeader = true) => (
        <DeviationInfo days={days} translate={translate} isHeader={isHeader} />
      ),
    }),
    [translate],
  );
};
